import { Component, OnInit,Output,Input,EventEmitter,ViewChild, ViewChildren, QueryList, HostListener, Inject, LOCALE_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatRow } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { DomSanitizer } from '@angular/platform-browser';
import { RechercheComponent } from '../recherche/recherche.component';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-avt-listes',
  templateUrl: './avt-listes.component.html',
  styleUrls: ['./avt-listes.component.scss']
})
export class AvtListesComponent implements OnInit 
{

  constructor(public http: HttpClient,public router:Router ,public route: ActivatedRoute,public sanitizer: DomSanitizer, @Inject(LOCALE_ID) private _local: string)
  {
    this.dataSource = new MatTableDataSource();
  }
  //@ViewChild//
  @ViewChild(MatSort,{static:true}) sort: MatSort;
  //ne pas supprimer, cette variable cer pour parcourir les composons recherche (RechercheComponent) utiliser dans le tableau
  @ViewChildren(RechercheComponent) public rechercheComponens : QueryList<RechercheComponent>
  @Input() showFilter : boolean = true;
  //listBtn exemlpe
  //listBtn:Array<any> = [{name:"ajouter",class:"colorOrenge",text:"Ajouter"}]
  @Input() listBtn:Array<any> = []
  @Input() displayedColumnsBrut :any;
  
  @Input() dataSourceBrut :Array<any> = [];  
  @Input() heightTable : string = "";
  @Input() colonnes : any = null;
  @Input() multipleSelect : boolean = false;
  @Input() matSortDisabled : boolean = false;
  @Input() api : string //= "http://unilog.ddns.net:86/api/";
  dataSource: MatTableDataSource<any>;  
  table:string="";
  row : any;
  oldRow : any;
  rows : any = [];
  chargement : boolean = true;
  displayedColumns :Array<string> = [];
  filter : number = 1;
  styleTab = {'height':""};
  textAlign=["left","center","right"];
  selection = new SelectionModel<any>(true, []);
  @Output() inputKeyup: EventEmitter<any> = new EventEmitter<any>();
  @Output() inputKeyDown: EventEmitter<any> = new EventEmitter<any>();
  @Output() btnTable: EventEmitter<any> = new EventEmitter<any>();
  //randomNumber :s'l y a +que un appele du comp avt-liste on doit faire la differance entre eux avec randomNumber
  randomNumber = Math.floor(Math.random() * (901) ) + 100;
  // pour composent rechereche 
  @Output() Champ_Enter: EventEmitter<any> = new EventEmitter<any>();
  @Output() Champ_Blur: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() outputAction: EventEmitter<any> = new EventEmitter<any>();
  // fin composent rechereche 
  rowIndex
  ngOnInit() 
  {
    if(!this.showFilter)
      this.filter = 0;
    if(this.heightTable == "")
      this.styleTab = {'height':"500px"};
    else
      this.styleTab = {'height':this.heightTable+"px"};    
    this.readParamUrl();
    // document.addEventListener('keyup', (e)=>
    // {
    //   if(e.key == "Control")
    //   this.multipleSelect = true;
    // });
    // document.addEventListener('keydown', (e)=>
    // {
    //   if(e.key == "Control")
    //   this.multipleSelect = false;
    // });
  }
 
  initVariable()
  {
    this.showFilter = true;
    this.listBtn =[]
    this.displayedColumnsBrut = {TableRD:[]};
    this.dataSourceBrut = [];  
    this.heightTable = "";
    this.btnTable = new EventEmitter<any>();
    this.dataSource = new  MatTableDataSource<any>();  
    this.colonnes = null;
    this.row = undefined;
    this.chargement  = true;
    this.displayedColumns = [];
    this.filter  = 1;
    this.styleTab = {'height':"500px"}
  }
  // @HostListener('window:keydown', ['$event'])
  // keyEvent(event: KeyboardEvent) 
  // {
  //   if (event.keyCode == 17) 
  //   {
  //     this.multipleSelect = true;
  //   }
  // }
  // @HostListener('window:keyup', ['$event'])
  // keyEvenst(event: KeyboardEvent) 
  // {
  //   if (event.keyCode == 17) 
  //   {
  //     this.multipleSelect = false;
  //   }
  // }
  getDisabled(row,column)
  {
    try
    {
      return row['disabled_'+column.TableRD_Champs]
    }
    catch
    {
      return false
    }
  }
  rechercheTable(code: string) 
  {
    return this.http.get<any>(this.api + 'recherche/TbRecherche?param=' + code);
  }
  rechercheData(codetb: string) 
  {       
    return this.http.get<any[]>(this.api + 'recherche/tbdata?tablere=' + codetb);
  }
  applyFilter(filterValue: string) 
  {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  clickColumn(event,i)
  {
    this.rowIndex = i;
  }
  deselectTable()
  {
    // var els = document.getElementsByClassName("rowClass"+this.randomNumber);
    // Array.prototype.forEach.call(els, function(el)
    // {      
    //   el.style="";
    // });
    if(this.oldRow)
      this.oldRow.style.backgroundColor="";
    this.row = null;
    this.rows = [];
  }
  clickRow(event, row) 
  {
    if(!this.multipleSelect)
    {
      this.deselectTable();
      event.currentTarget.style.backgroundColor="rgb(160, 189, 243)";
      this.row = row; 
      this.oldRow = event.currentTarget;
      this.btnTable.emit({row:row,name:"selectRow",data:this.dataSource.data,index:this.rowIndex});
    }
    else
    {
      if(event.currentTarget.style.backgroundColor == "rgb(160, 189, 243)")
      {
        event.currentTarget.style.backgroundColor = "";
        this.rows = this.rows.filter(r => {return r != row});
      }
      else
      {
        event.currentTarget.style.backgroundColor = "rgb(160, 189, 243)";
        this.rows.push(row);
      }
      this.btnTable.emit({rows:this.rows,name:"selectRow",data:this.dataSource.data,index:this.rowIndex});
    }
  }
  dblclickRow(event,row)
  {
    this.row = row; 
    this.btnTable.emit({row:row,name:"dblclickRow",data:this.dataSource.data,index:this.rowIndex});
  }
  setDataSource(data)
  {
    this.dataSource = new MatTableDataSource(data);  
    this.dataSource.filterPredicate = this.createFilter();
    //@ViewChild//
    this.dataSource.sort = this.sort; 
    if(this.displayedColumns.length>0)    
    {
      this.chargement = false;
    }
  }
  readParamUrl()
  {    
    this.route.params.subscribe(params => 
    {
      this.table = params['table'];
      this.init()
    });
  }
  setDisplayedColumns(data)
  {
    this.displayedColumnsBrut = this.sortColomns(data);
    this.displayedColumns=[];
    for (let obj of this.displayedColumnsBrut.TableRD) 
    {
      this.displayedColumns.push(obj["TableRD_Champs"]);
    }
    if(this.dataSource.data.length>0)
    {
      this.chargement = false;
    }  
  }
 showFooter()
 {
   //return (this.displayedColumnsBrut.footer == undefined)? true :  displayedColumnsBrut.footer
 }
  init()
  {  
    if(this.table != undefined)
      this.initVariable()
    this.setColonne(this.displayedColumnsBrut);
    this.setData();
  }
  setColonne(displayedColumnsBrut)
  { 
    this.displayedColumnsBrut = displayedColumnsBrut;
    if(this.displayedColumnsBrut.TableRD.length == 0)  
    {
      this.rechercheTable(this.table).subscribe(data =>
      {   
        this.setDisplayedColumns(data);
        this.displayedColumnsBrut["read_Only"]=true;
      });
    }
    else
    {
      this.setDisplayedColumns(this.displayedColumnsBrut);
    }
  }
  sortColomns(data)
  {
    data.TableRD = data.TableRD.sort(function(a, b)
    {
      return a.TableRD_Ordre - b.TableRD_Ordre;
    })
    return data;
  }
  setData()
  {
    if(this.table != undefined)
      this.rechercheData(this.table).subscribe(data => 
      {   
          this.setDataSource(data);
      }); 
    else
      this.setDataSource(this.dataSourceBrut);
  }
  clickBtnHeat(name :string)
  {
    this.btnTable.emit({row:this.row,name:name,data:this.dataSource.data,index:this.rowIndex});    
  }
  clickBtnTable(row,name,index)
  {
    this.btnTable.emit({row:row,name:name,data:this.dataSource.data,index:index});
  }
  onkeyup()
  {
    var myJson : any={};    
    const listInput: any = document.getElementsByClassName("inputSearch"+this.randomNumber);       
    Array.prototype.forEach.call(listInput, (el => 
    {
      myJson[el.name]=el.value
    }));          
    this.dataSource.filter = JSON.stringify(myJson);    
  }
  createFilter(): (data: any, filter: string) => boolean 
  {
    let filterFunction = ((data, filter) => 
    {
      var test : boolean = true;
      let searchTerms = JSON.parse(filter);
      this.displayedColumnsBrut.TableRD.forEach(col => 
      {
        if(searchTerms[col["TableRD_Champs"]] != undefined && searchTerms[col["TableRD_Champs"]] != null && searchTerms[col["TableRD_Champs"]] != "")
          test = test && data[col["TableRD_Champs"]].toString().toLowerCase().indexOf(searchTerms[col["TableRD_Champs"]].toLowerCase())!= -1
      });     
      return test;       
    });
    
    return filterFunction;
  }

  getSomme(colomn)
  {
    
    var decimalPipe = new DecimalPipe("fr-FR");

    var somme : number = 0;
    if(colomn.valueTotal != undefined)
      if(typeof colomn.valueTotal === "number")
        return decimalPipe.transform(colomn.valueTotal, colomn.TableRD_Format) 
      else
        return colomn.valueTotal
    else
    {
      if(this.dataSource.filteredData.length>0)
      {
          somme = 0
          this.dataSource.filteredData.forEach(data =>
          {
            try
            {
              var nbr = parseInt(data[colomn.TableRD_Champs])
              if(typeof(nbr) == "number" && nbr.toString() == data[colomn.TableRD_Champs].toString())
                somme+=nbr
            }catch{}
          })
          // parseInt(this.dataSource.filteredData.map(col => col[colomn.TableRD_Champs]).reduce(
          //   (accumulator, currentValue) => 
          //         parseInt(accumulator)? parseInt(accumulator) : 0 + parseInt(currentValue)? parseInt(currentValue) : 0
          //      ,0))
      }
      if(typeof somme === "number")
      {
        try
        {
          return decimalPipe.transform(somme, colomn.TableRD_Format) ;
        }
        catch
        {
          return somme
        }

      }
      else
        return ''
    }
    
  }
  getNewDate(time)
  {
    return new Date("2000-01-01 " + time) ;
  }
  
  getStyleInput(column)
  {
    return {'width':'100%','text-align':this.textAlign[column.TableRD_Alligement]}
  }
  getStyle(column)
  {
    return {'width':column.TableRD_Largeur+'px','text-align':this.textAlign[column.TableRD_Alligement]}
  }
  getValueSelect(select,column)
  {
    var value
    var expression = "value = select." + column.valueSelect;
    eval(expression)
    return value;
  }
  getTextSelect(select,column)
  {
    var text;
    var expression = "text = select."+column.textSelect;
    eval(expression)
    return text;
  }
  getClass(column)
  {
    var testIcon = ""
    if(column.TableRD_Type == 103)
      testIcon = "Icon"
    if(column.TableRD_Class == undefined ||  column.TableRD_Class == null)
      return 'colorBlue' + testIcon;
    else
      return column.TableRD_Class + testIcon;
  }
  onBlur(event,row,column,index)
  {
    this.outputAction.emit({event : event, row : row, column : column,index:index, action : "onBlur"});
  }
  onInput(event,row,column,index)
  {
    this.outputAction.emit({event : event, row : row, column : column,index:index, action : "onInput"});
  }
  ChampBlur(event,row,column,index)
  {
    //column composon rechercher
    if(column.TableRD_Type == 3)
    {
      row[column.TableRD_Champs] = event; 
    }
    this.Champ_Blur.emit({colonneToReturn : event, row : row, column : column,index:index});
  }
  ChampEnter(event,row,column,index)
  {
    //column composon rechercher
    if(column.TableRD_Type == 3)
    {
      row[column.TableRD_Champs] = event; 
    }
    this.Champ_Enter.emit({colonneToReturn : event, row : row, column : column,index:index});
  }
  onInputKeyup(event,row,column,index)
  {
    //column composon rechercher
    if(column.TableRD_Type == 3)
    {
      row[column.TableRD_Champs] = event.valueColonneToReturn; 
    }
    this.inputKeyup.emit({event : event, row : row, column : column,index:index});
    this.outputAction.emit({event : event, row : row, column : column,index:index, action : "onInputKeyup"});
  }
  onInputKeyDown(event,row,column,index)
  {
    //column composon rechercher
    if(column.TableRD_Type == 3)
    {
      row[column.TableRD_Champs] = event.valueColonneToReturn; 
    }
    this.inputKeyDown.emit({event : event, row : row, column : column,index:index})
    this.outputAction.emit({event : event, row : row, column : column,index:index, action : "onInputKeyDown"});
  }
  onSelectChange(event,row,column,index)
  {
    this.selectChange.emit({event : event, row : row, column : column,index:index});
    this.outputAction.emit({event : event, row : row, column : column,index:index, action : "onSelectChange"});
  }

  onCheckboxChange(event,row,column,index)
  {
    this.outputAction.emit({event : event, row : row, column : column,index:index, action : "onCheckboxChange"});
  }
  onSelectionAutocompleteChanged(event,row,column,index)
  {
    this.outputAction.emit({event : event, row : row, column : column,index:index, action : "onSelectionAutocompleteChanged"});
  }
  genererColonne(footer,index)
  {
    var col = []
    for(var i = 0; i<footer.length;i++)
    {
      col.push("col-" + index + "-" + i)
    }
    return col;
  }


  





















  

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() 
  {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.data.forEach(row => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?): string 
  {
    if (!row) 
    {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} `;
  }
  checkboxClick(event,row)
  {
    event.stopPropagation();
    //this.clickRow(event.currentTarget.parentNode.parentNode,row,true)
  }
  checkboxChange(event,row)
  {
    event ? this.selection.toggle(row) : null;
    this.btnTable.emit({selection:this.selection,name:"selectRow",data:this.dataSource.data});

  }
  getHref(row,column) : string
  {
    var str = column.tabHref.find(r => {return this.isEgaleObject(r.row,row)})
    if(str != undefined)
      return str.href
    else
      return ""
  }
  isPopap(row,column) : boolean
  {
    var str = column.tabHref.find(r => {return this.isEgaleObject(r.row,row)})
    if(str != undefined && str.popap)
      return true
    else
      return false
  }
  
  popupCenter(row,column) 
  {
    var url, largeur, hautteur
    var str = column.tabHref.find(r => {return this.isEgaleObject(r.row,row)})
    if(str != undefined)
    {
      url = str.href;
      largeur = str.largeur;
      hautteur = str.hautteur;
      if (!largeur)
        largeur = (window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width) - 100;
      if (!hautteur)
          hautteur = (window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height) - 100
      const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
      const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

      const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
      const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

      const systemZoom = width / window.screen.availWidth;
      const left = (width - largeur) / 2 / systemZoom + dualScreenLeft
      const top = (height - hautteur) / 2 / systemZoom + dualScreenTop;
      window.open
        (
            location.origin + url, '_blank',
            `
      location=yes
      scrollbars=yes,
      status=yes,
      width=${largeur / systemZoom}, 
      height=${hautteur / systemZoom}, 
      top=${top}, 
      left=${left}
      `
        )
    }
    
}
  isEgaleObject(obj1:Object, obj2: Object)
  {
      var str1 = JSON.stringify(obj1);
      var str2 = JSON.stringify(obj2);
      return str1 == str2;
  }
  getDataSelect(row,column,index)
  {
    return column.dataSelect[index];
  }
}
